// ABOUTME: Main dashboard layout with sidebar and outlet
// ABOUTME: Wraps protected routes with navigation

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { useHypotheses } from '@/hooks/useHypotheses';
import { useAuth } from '@/contexts/AuthContext';
import logo from '@/assets/logo-black.svg';

export const DashboardLayout: React.FC = () => {
  const { data: categories, isLoading } = useHypotheses();
  const { user, logout } = useAuth();
  const [showWaziriModal, setShowWaziriModal] = useState(false);

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      {/* Header spans full width */}
      <div className="bg-white border-b border-gray-200 px-8 py-4 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src={logo} alt="ALX Logo" className="h-10" />
            <div className="border-l border-gray-300 pl-4">
              <div className="flex items-center gap-2">
                <h1 className="text-xl font-bold text-gray-900">Waziri</h1>
                <div className="relative">
                  <button
                    onMouseEnter={() => setShowWaziriModal(true)}
                    onMouseLeave={() => setShowWaziriModal(false)}
                    className="w-5 h-5 rounded-full bg-gray-200 text-gray-600 text-xs flex items-center justify-center hover:bg-gray-300 cursor-help"
                  >
                    ?
                  </button>
                  {showWaziriModal && (
                    <div
                      className="absolute left-0 top-7 z-50 w-96 bg-white border border-gray-300 rounded-lg shadow-xl p-5"
                      onMouseEnter={() => setShowWaziriModal(true)}
                      onMouseLeave={() => setShowWaziriModal(false)}
                    >
                      <h3 className="font-semibold text-gray-900 mb-2">What is Waziri?</h3>
                      <p className="text-sm text-gray-700 mb-4">
                        <em>Waziri</em> is an Arabic term, also used in Swahili, meaning "advisor" or
                        "counselor to the king"—providing trusted strategic guidance to us.
                      </p>

                      {/* Contact Card */}
                      <div className="border-t pt-4">
                        <p className="text-xs text-gray-500 mb-2">Research Contact</p>
                        <div className="flex items-center gap-3">
                          <img
                            src="/sophia-seketo.jpg"
                            alt="Sophia Seketo"
                            className="w-12 h-12 rounded-full object-cover"
                          />
                          <div>
                            <p className="text-sm font-semibold text-gray-900">Sophia Seketo</p>
                            <p className="text-xs text-gray-500">Senior Research Analyst</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <p className="text-xs text-gray-600">FIG Learning-Design CoE — Interview Analysis</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-700">
              {user?.username}
            </span>
            <button
              onClick={logout}
              className="px-4 py-2 bg-alx-blue hover:bg-alx-green text-white hover:text-alx-blue rounded-lg transition-colors text-sm font-medium"
            >
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Main content area with sidebar */}
      <div className="flex flex-1 overflow-hidden">
        <Sidebar categories={categories || []} isLoading={isLoading} />

        <div className="flex-1 overflow-y-auto">
          {/* Main content (nested routes) */}
          <Outlet />
        </div>
      </div>
    </div>
  );
};
